export default __webpack_public_path__ + "static/media/greenArrowDown.0e519c86.svg";